import { styleTokens } from "@ideally-ltd/design-tokens";
import { styled } from "@linaria/react";
import { PDialog } from "@prime/PDialog/PDialog";
import dialog_bg from "assets/images/svg/dialog_bg.svg";

const ProjectLinkSurveyProcessingModal = styled(PDialog)`
  .p-dialog-content {
    background-image: url(${dialog_bg});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    background-color: #f393df;
    padding-top: 2rem;
    & > h4 {
      background-color: white;
      height: 3.5rem;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      font-family: ${styleTokens.fontFamily.Inter};
      font-size: 1.625rem;
      font-style: normal;
      font-weight: 600;
      line-height: 2rem; /* 123.077% */
      margin: 0px;
      width: fit-content;
      border: 1px solid black;

      display: flex;
      align-items: center;
    }
    & > div {
      margin-top: -1px;
      background-color: white;
      height: 3.25rem;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      font-family: ${styleTokens.fontFamily.Inter};
      font-size: 0.875rem;
      font-style: normal;
      font-weight: 600;
      width: fit-content;
      border: 1px solid black;

      display: flex;
      align-items: center;
    }
  }
`;

export const ProjectLinkSurveyProcessingModalStyle = {
  ProjectLinkSurveyProcessingModal,
};
